import { render, staticRenderFns } from "./cleaner-portal.vue?vue&type=template&id=f26b7f52"
import script from "./cleaner-portal.vue?vue&type=script&lang=ts"
export * from "./cleaner-portal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports